import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../app.constant';
@Injectable({
  providedIn: 'root'
})

export class Fileservice {
  private host = environment.apiHost;
  private baseUrl = `${this.host}/adFile`;
  // private baseUrl = "http://192.168.0.5:8081/adFile";
  constructor(private http: HttpClient) { }
  saveFile(formData: any): Observable<any> {
    // alert("from file service...");
    return this.http.post(`${this.baseUrl}`, formData);
  }
}


